import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { areThereAnyTaxIdsForCountry } from "@/react/utils/paywalls/taxId/helpers";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { CheckoutFormTaxIdForm } from "./CheckoutFormTaxIdForm";

export const CheckoutFormTaxIdField = () => {
  const { watch } = useFormContext();
  const {
    community_member_billing_info_attributes: {
      address_country: memberAddressCountry,
    },
  } = watch();

  const {
    isMemberAddressRequired,
    isTaxIdCollectionEnabled,
    shouldShowTaxIdForm,
    enableTaxIdCollection,
  } = usePaywallCheckoutContext();

  if (
    !shouldShowTaxIdForm ||
    (isMemberAddressRequired && !memberAddressCountry) ||
    (memberAddressCountry && !areThereAnyTaxIdsForCountry(memberAddressCountry))
  ) {
    return null;
  }

  if (isTaxIdCollectionEnabled) {
    return <CheckoutFormTaxIdForm />;
  }

  return (
    <div className="flex flex-row items-center gap-x-1 underline">
      <Button
        type="button"
        variant="link"
        className="!p-0"
        onClick={enableTaxIdCollection}
      >
        <Typography.LabelSm weight="normal" color="text-default">
          {t("paywall_checkout.form.tax_id.cta")}
        </Typography.LabelSm>
      </Button>
    </div>
  );
};
